module.exports = __webpack_public_path__ + "img/default_avatar_girl.e73401ce.png";